import {createContext, useContext, useState} from "react";

import {AppFont, basicFont, bigFont} from "../model/Constants";

export type FontProps = {
  font: AppFont;
  refreshFont: () => void;
};

export function getFont() {
  const font = sessionStorage.getItem('fontSize');
  return font==="bigFont" ? bigFont : basicFont;
};

const baseF = ()=> {  };
const fontContext = createContext<FontProps>({font: basicFont, refreshFont: baseF});

export function useFont() {
  return useContext(fontContext);
}

export function FontProvider({ children }: any) {
    const [font, setFont] = useState<AppFont>(getFont());

    const refreshFont = ()=> {
        setFont(getFont());
        };

  return (
    <fontContext.Provider
      value={{font, refreshFont}}
    >
      {children}
    </fontContext.Provider>
  );
}
